export default "__VITE_ASSET__a18b0c96__"